module.exports = __webpack_public_path__ + "img/Racine_Energie_120X35.63545fb7.png";